import script from "./ScrollUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollUp.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollUp.vue?vue&type=style&index=0&id=bf75d140&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf75d140"]])

export default __exports__